export default __webpack_public_path__ + "static/media/grid.3a0580ac.png";